import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {Observable, Subscription} from "rxjs";
import {Centre} from "../../../../interfaces/Centres";
import {FullChild} from "../../../../interfaces/FullChild";
import {MatSelectChange} from "@angular/material/select";
import {ChildService} from "../../../../components/child/child.service";
import {Router} from "@angular/router";
import {CentreService} from "../../../../services/centre.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {HighlightService} from "./highlight.service";
import {ConfirmDialogComponent} from "../../../../confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {LogService} from "../../../../services/log.service";
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-highlight',
  templateUrl: './highlight.component.html',
  styleUrls: ['./highlight.component.scss']
})
export class HighlightComponent implements OnInit, OnChanges, OnDestroy  {
  // ── Nested-mode inputs (passed from Consolidated Highlights parent) ──
  @Input() isNestedComponent: boolean = false;
  @Input() selectedCentreCodes: string[] = [];
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;

  displayedColumns: String[] = ['position', 'centreCode', 'childName', 'highlightType', 'eventDate','addedBy', 'Action'];
  @ViewChild(MatPaginator) paginator1!: MatPaginator;
  @ViewChild(MatSort) sort1!: MatSort;
  dataSource!: MatTableDataSource<any>;
  centres$!: Observable<Centre[]>;
  children$?: Observable<FullChild[]>
  highlighTypeList$!: Observable<any[]>
  mSelectedCentre: any;
  mChildren!: FullChild[];
  selectedChildData: string = '';
  selectedChild: any;
  private subscriptions: Subscription[] = [];  // Track all subscriptions
  constructor(private readonly mChildService: ChildService,
              private mRouter: Router,
              private firestore: AngularFirestore,
              public dialog: MatDialog,
              private snackBar: MatSnackBar,
              private mDatabase: AngularFireDatabase,
              private highlighService: HighlightService,
              private mLogService: LogService,
              private readonly mCentreService: CentreService) {
    this.centres$ = this.mCentreService.getAllCentres();
    this.highlighTypeList$ = mDatabase.list<any>('types/Highlights Type').valueChanges();
  }

  ngOnInit(): void {
    this.featchHighlightData()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isNestedComponent &&
      (changes['selectedCentreCodes'] || changes['startDate'] || changes['endDate'])) {
      this.featchHighlightData();
    }
  }

  featchHighlightData() {
    // In nested mode use filter-aware query; standalone uses plain query
    const source$ = this.isNestedComponent
      ? this.highlighService.getHighlightsByFilter(this.selectedCentreCodes, this.startDate ?? undefined, this.endDate ?? undefined)
      : this.highlighService.getHighlights();

    const sub = source$.subscribe((data: any) => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator1;
    });
    this.subscriptions.push(sub);
  }


  onCentreSelected($event: MatSelectChange) {
    this.mSelectedCentre = $event.value
    const sub = this.mChildService.getAllotedChildListByCenter(this.mSelectedCentre)
        .subscribe(res => this.mChildren = res.filter(child => child.reason !== 'OM SHANTI')
        )
    this.subscriptions.push(sub);
  }

  applyFilter($event: Event) {
    const filterValue = ($event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  clearAll() {
    this.mSelectedCentre = ''
    this.selectedChildData = ''
    this.featchHighlightData();
  }

  downloadExcel() {
    if (!this.dataSource || !this.dataSource.data || this.dataSource.data.length === 0) {
      this.snackBar.open('No data available to download', 'Close', { duration: 2000 });
      return;
    }

    const exportData = this.dataSource.data.map((item: any, index: number) => ({
      'Sr No': index + 1,
      'Centre Code': item.centreCode || '',
      'Child Name': item.childName || '',
      'Highlight Type': Array.isArray(item.highlights)
        ? item.highlights.map((h: any) => h.highlight).join(', ')
        : '',
      'Event Date': item.eventDate
        ? new Date(item.eventDate.seconds * 1000).toLocaleDateString()
        : '',

    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Child Highlights');

    XLSX.writeFile(workbook, 'AL_Child_Highlights.xlsx');

    //  LOG ACTIVITY (same pattern as rest of module)
    const activity = {
      date: new Date().getTime(),
      section: 'Child Highlight',
      action: 'Download',
      description: 'Child Highlight list downloaded as Excel',
      currentIp: localStorage.getItem('currentip')!
    };
    this.mLogService.addLog(activity);

    this.snackBar.open('Excel downloaded successfully', 'Close', { duration: 2000 });
  }


  onChildSelect($event: MatSelectChange) {
    this.selectedChild = $event.value.childCode
    console.log(JSON.stringify(this.selectedChild))
  }

  searchChildByCode() {
    if (!this.mSelectedCentre && !this.selectedChildData) {
      this.dataSource.filter = '';
      return;
    }

    const sub = this.highlighService.getHighlights().subscribe((data: any) => {
      let filteredData = data;
      if (this.mSelectedCentre) {
        filteredData = filteredData.filter((item: any) => item.centreCode === this.mSelectedCentre);
      }
      if (this.selectedChildData) {
        filteredData = filteredData.filter((item: any) => item.childCode === this.selectedChild);
      }
      this.dataSource = new MatTableDataSource(filteredData);
    });
    this.subscriptions.push(sub);
  }


  ViewReportChildCaseStudy(id: any) {

    // ⭐ LOG ACTIVITY
    const activity = {
      date: new Date().getTime(),
      section: 'Child Highlight',
      action: 'View',
      description: `Viewed highlight report: ${id}`,
      currentIp: localStorage.getItem('currentip')!
    };
    this.mLogService.addLog(activity);

    this.mRouter.navigateByUrl(`home/reports/view-highlight/${id}`);
  }


  // editReport(id:any) {
  //   this.mRouter.navigateByUrl(`home/reports/add-highlight/${id}`);
  // }

  editReport(id: any) {

    // ⭐ LOG ACTIVITY
    const activity = {
      date: new Date().getTime(),
      section: 'Child Highlight',
      action: 'Update',
      description: `Opened edit screen for highlight: ${id}`,
      currentIp: localStorage.getItem('currentip')!
    };
    this.mLogService.addLog(activity);

    this.mRouter.navigateByUrl(`home/reports/add-highlight/${id}`);
  }


  deleteReport(id:any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      height: '200px',
      data: {
        title:'Confirmation',
        message: 'Are you sure you want to delete this highlight?',
      }
    });
    const sub = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.highlighService.deleteHighlight(id).then(() => {
          // ⭐ LOG ACTIVITY
          const activity = {
            date: new Date().getTime(),
            section: 'Child Highlight',
            action: 'Delete',
            description: `Deleted highlight record: ${id}`,
            currentIp: localStorage.getItem('currentip')!
          };
          this.mLogService.addLog(activity);

          this.snackBar.open('Deleted successfully!', 'Close', { duration: 3000 });
        })
      }
    });
    this.subscriptions.push(sub);
  }

  addHighlightReport() {
    this.mRouter.navigateByUrl('home/reports/add-highlight');
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions to prevent memory leaks
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

    protected readonly PermissionType = PermissionType;
}
